import { render, staticRenderFns } from "./properties_list.vue?vue&type=template&id=1d8a1977&scoped=true"
import script from "./properties_list.vue?vue&type=script&lang=js"
export * from "./properties_list.vue?vue&type=script&lang=js"
import style0 from "./properties_list.vue?vue&type=style&index=0&id=1d8a1977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a1977",
  null
  
)

export default component.exports